/**
 * セレクト/ドロップダウンのトリガー右端に表示するアイコン群。
 * ▼ などのベタ塗り三角は見た目のインパクトが強いため、細い線画に統一する。
 * - ChevronIcon: その場でリストが開くドロップダウン用。開いている間は上向きに回転。
 * - ExpandIcon: クリックで別画面(モーダル)が開く場合用のマキシマイズ(展開)アイコン。
 */

/** 下向きシェブロン。open=true で上向き(180度回転)。currentColor で塗る。 */
export function ChevronIcon({ open = false }: { open?: boolean }) {
  return (
    <svg
      width="10"
      height="6"
      viewBox="0 0 10 6"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ transform: open ? 'rotate(180deg)' : undefined, transition: 'transform 0.15s ease' }}
      aria-hidden="true"
    >
      <path d="M1 1l4 4 4-4" />
    </svg>
  );
}

/**
 * 3 点リーダー (メニュー / 「その他」トリガー)。サイト全体で共通化し、丸の半径は 1.2 (16px 基準) に
 * 揃える (2026-09-09: 旧 1.5 / 24px 基準 r=2 から小さくした)。vertical=true で縦並び。
 * 塗りは currentColor。
 */
export function ThreeDotsIcon({ vertical = false, size = 16 }: { vertical?: boolean; size?: number }) {
  const r = 1.2;
  const dots = vertical
    ? [[8, 3], [8, 8], [8, 13]]
    : [[3, 8], [8, 8], [13, 8]];
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">
      {dots.map(([cx, cy]) => <circle key={`${cx}-${cy}`} cx={cx} cy={cy} r={r} />)}
    </svg>
  );
}

/** 右上向きの斜め矢印。別画面(モーダル)が開くドロップダウンの目印。 */
export function ExpandIcon() {
  return (
    <svg
      width="11"
      height="11"
      viewBox="0 0 12 12"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M3 9L9 3" />
      <path d="M4.5 3H9v4.5" />
    </svg>
  );
}
